










import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { v1 } from 'uuid'
import LivePlayer from './components/LivePlayer.vue'
import AuthorInfo from './components/AuthorInfo.vue'
import TalkArea from './components/TalkArea.vue'
import { liveRoomTypeenum } from '@/common/enums'
import { getUserInfo } from 'apiUtils/Login'
import { getTimeGap } from '../../utils/index'
import { saveLiveRoomUpShare } from '@/api/Anchor'
import { addUpHeaters } from './utils'

import { now } from 'moment';

@Component({
  components: {
    LivePlayer,
    AuthorInfo,
    TalkArea
  },
})
export default class ZnPlayer extends Vue {
  private sid!: string
  private roomId!: string
  private userId!: string
  private userName = '游客'
  private userImg = 'http://hrmsv3-mlearning-stg5.pingan.com.cn:20083/learn/app/default1'
  private loading = false
  private needAuth = false
  private featureList = ['1', '2', '3', '4']
  private clickTime = 0
  private created () {
    getTimeGap()
    this.getLoginInfo()
  }

  private mounted () {
    if (this.$route.query && this.$route.query.featureList) {
      this.featureList = (this.$route.query.featureList! as string).split(',') as any[]
    }
  }

  private getLoginInfo () {
    const { sid, roomId, userId, appId } = this.$route.query
    if (sid) {
      this.needAuth = true
      this.sid = sid as string
      this.roomId = roomId as string
      this.userId = userId as string
      this.getUserInfo()
    } else {
      this.sid = `$ZNYOUKE@${v1().replace(/-/g, '').slice(0, 23).toUpperCase()}`
      this.userId = `$ZNYOUKE@${v1().replace(/-/g, '').slice(0, 20).toUpperCase()}uid`
      this.roomId = this.$route.query.roomId as string
      this.$store.dispatch('updateUserInfo', {
        userName: this.userName,
        userImg: this.userImg,
        userId: this.userId,
        isTourist: true
      })
    }
    if (appId) {
      this.$store.dispatch('setAppId', appId)
    }
    this.$store.dispatch('setSid', this.sid)
  }

  private async getUserInfo () {
    this.loading = true
    const resp = await getUserInfo({
      sid: this.sid,
      nonGzip: 1
    })
    this.loading = false
    if (+resp.code === 0) {
      const { userName,
              userImg = 'http://hrmsv3-mlearning-stg5.pingan.com.cn:20083/learn/app/default1',
            } = resp.body;
      this.userName = userName
      this.userImg = userImg
       this.$store.dispatch('updateUserInfo', {
        userName: this.userName,
        userImg: this.userImg,
        userId: this.userId,
      })
    }
  }

  private saveLiveRoomUpShare () {
    const nowTime = Date.now()
    if (this.clickTime && nowTime - this.clickTime < 300) {
      this.clickTime = 0
      addUpHeaters(this)
      saveLiveRoomUpShare(this.roomId, this.$store.state.sid)
    }
    this.clickTime = Date.now()
  }

  private get showAuthInfo () {
    return this.featureList.includes('1')
  }

  private get showTalkBtn () {
    return this.featureList.includes('2')
  }

  private get showUpBtn () {
    return this.featureList.includes('3')
  }

  private get showGiftListBtn () {
    return this.featureList.includes('4')
  }

  private get isLiveStream () {
    return (this.$route.params.liveRoomType || '1') as string === liveRoomTypeenum.LIVEING
  }
}
